import { render, staticRenderFns } from "./FindPositionLite.vue?vue&type=template&id=b6c00e64&scoped=true&"
import script from "./FindPositionLite.vue?vue&type=script&lang=js&"
export * from "./FindPositionLite.vue?vue&type=script&lang=js&"
import style0 from "./FindPositionLite.vue?vue&type=style&index=0&id=b6c00e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c00e64",
  null
  
)

export default component.exports